import Hls from 'hls.js';
import {dataset, findMany, on, removeClass, whenElementIsInView} from '../helpers';

const videoElements = findMany('[data-video-stream]');
const mediaQuery = matchMedia('screen and (min-width: 1024px)');

const getVideoFile = (video) => dataset(video, 'src');

let shouldPlay = false;

videoElements.forEach(video => {
    if (!video) {
        return;
    }

    let hls;

    const playVideo = async () => {
        try {
            if (video.paused && shouldPlay) {
                await video.play();
            }
        } catch (error) {
            console.log(error);
        }

        requestAnimationFrame(() => {
            removeClass(video, 'opacity-0');
        });
    };

    const updateMedia = () => {
        const videoSource = getVideoFile(video);

        if (Hls.isSupported()) {
            if (hls) {
                hls.destroy();
            }

            hls = new Hls();
            hls.loadSource(videoSource);
            hls.attachMedia(video);

            hls.startLevel = mediaQuery.matches ? 10 : 1;

            hls.on(Hls.Events.MANIFEST_PARSED, () => {
                playVideo();

                if (mediaQuery.matches) {
                    hls.loadLevel = hls.levels.length - 1;
                }
            });

            hls.on(Hls.Events.ERROR, function (event, data) {
                if (data.fatal && data.type === Hls.ErrorTypes.OTHER_ERROR && data.details === 'internalException') {
                    console.error('Internal exception error occurred:', data);
                }
            });
        } else if (video.canPlayType('application/vnd.apple.mpegurl')) {
            video.src = videoSource;
            on('loadedmetadata', playVideo, video);
        } else {
            console.error('HLS is not supported in this browser');
        }
    };

    // const debouncedUpdateMedia = debounce(updateMedia, 200);

    // window.addEventListener('resize', debouncedUpdateMedia);

    updateMedia();

    whenElementIsInView(video, inView => {
        shouldPlay = inView;

        if (!inView) {
            video.pause();
        } else {
            playVideo(video);
        }
    });
});

